import React from 'react';

import { token } from '@atlaskit/tokens';
import type { IconProps } from '@atlaskit/icon';
import Icon from '@atlaskit/icon';

const CloudSavingGlyph = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="17" height="18" viewBox="0 0 17 18" fill="none">
		<g clipPath="url(#clip0_1_33)">
			<path
				d="M5.08333 8.54167C5.4055 8.54167 5.66667 8.80283 5.66667 9.125C5.66667 10.5333 6.77572 11.6826 8.1681 11.7471L8.29167 11.75H8.92458L8.17085 10.9958C7.95932 10.7843 7.94421 10.4507 8.12553 10.2217L8.17085 10.1709C8.38239 9.95932 8.71597 9.94421 8.94493 10.1255L8.99581 10.1709L10.7458 11.9209C10.9573 12.1324 10.9725 12.466 10.7911 12.6949L10.7458 12.7458L8.99581 14.4958C8.76801 14.7236 8.39866 14.7236 8.17085 14.4958C7.95932 14.2843 7.94421 13.9507 8.12553 13.7217L8.17085 13.6709L8.92458 12.9167H8.29167C6.19759 12.9167 4.5 11.2191 4.5 9.125C4.5 8.80283 4.76117 8.54167 5.08333 8.54167ZM8.99581 3.17085C9.20735 3.38239 9.22246 3.71596 9.04114 3.94493L8.99581 3.99581L8.2415 4.75H8.875C10.9691 4.75 12.6667 6.44759 12.6667 8.54167C12.6667 8.86383 12.4055 9.125 12.0833 9.125C11.7612 9.125 11.5 8.86383 11.5 8.54167C11.5 7.13334 10.3909 5.98405 8.99857 5.91952L8.875 5.91667H8.2415L8.99581 6.67085C9.20735 6.88239 9.22246 7.21597 9.04114 7.44493L8.99581 7.49581C8.78428 7.70735 8.4507 7.72246 8.22173 7.54114L8.17085 7.49581L6.42085 5.74581C6.20932 5.53428 6.19421 5.2007 6.37553 4.97173L6.42085 4.92085L8.17085 3.17085C8.39866 2.94305 8.76801 2.94305 8.99581 3.17085Z"
				fill={token('color.icon.success')}
			/>
		</g>
		<defs>
			<clipPath id="clip0_1_33">
				<rect width="16" height="18" fill="white" transform="translate(0.5)" />
			</clipPath>
		</defs>
	</svg>
);

export type CloudSavingIconProps = Omit<IconProps, 'glyph'>;

export const CloudSavingIcon = (props: CloudSavingIconProps) => (
	<Icon glyph={CloudSavingGlyph} testId="CloudSaving-icon" {...props} />
);
